import tempMeeApi from '../../../apis/tempMee';

/**
 * Updates an existing job posting
 *
 * @param {import('../types/UpdateJobPosting.parameters').IUpdateJobPostingPayload} payload - Request payload
 *
 * @returns {Promise<void>}
 *   Returns 204 No Content on success
 */
export const updateJobPosting = async (payload) => {
  await tempMeeApi.patch(
    `/posting-service/admin/postings/${payload.postingId}`,
    {
      title: payload.jobTitle,
      professionType: payload.professionType,
      subProfession: payload.subProfession,
      officeSpecialty: payload.officeSpecialty,
      payType: payload.payType,
      maxRate: parseInt(payload.maxRate, 10) || parseInt(payload.minRate, 10) || 0,
      minRate: parseInt(payload.minRate, 10),
      benefits: payload.benefits,
      benefitsOther: payload.benefitsOther,
      scheduleType: payload.scheduleType,
      expectedDays: payload.expectedDays,
      description: payload.jobDescription?.raw?.replace(/&nbsp;/g, ' '),
      officeSelected: payload.officeSelected,
      status: payload.status,
      recruiterId: payload.recruiterId,
      recruiterEmail: payload.recruiterEmail || null,
    }
  );
};
